// Underlying HTTP client implementation with Fetch 

function responseOrError(response) {
    if (!response.ok) {
        if (response.status === 400 && response.body) 
            return response.json().then(err => Promise.reject(err));
        else
            throw new Error(`Network request responded with ${response.status}`);
    }
    else if (response.redirected && response.url) { 
        window.location.href = response.url;
        return;
    }
    return response.json();
}

function buildUrl(url, params) {
    if (params) {
        return `${url}?${new URLSearchParams(params)}`;
    }
    else {
        return url;
    }
}

function bearerHeader(bearer) {
    return {
        'Authorization': `Bearer ${bearer}`
    };
}

export const Get = async ({ url, queryParams, bearer }) => {
    const requestUrl = buildUrl(url, queryParams);
    const requestOptions = bearer ? { headers: bearerHeader(bearer) } : {};

    const response = await fetch(requestUrl, requestOptions);
    return responseOrError(response);
}

export const Post = async ({ url, data, bearer, isJson = true }) => 
{
    let requestOptions = { method: 'POST' };

    if (isJson) {
        requestOptions.body = JSON.stringify(data);
        requestOptions.headers = { 'Content-Type': 'application/json' };
    } else {
        requestOptions.body = data;
    }

    if (bearer) {
        requestOptions.headers = {
            ...requestOptions.headers,
            ...bearerHeader(bearer)
        }
    }

    const response = await fetch(url, requestOptions);
    return responseOrError(response);
}
